<!--
 * @Author: your name
 * @Date: 2021-09-07 18:55:00
 * @LastEditTime: 2021-09-23 11:06:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/components/courseName.vue
-->
<!--  -->
<template>
  <div
    class="course-num"
    v-if="courseBaseData.name"
  >
    <h1>
      <i
        v-if="courseBaseData.name.substr(0, 1) == '【'"
        class="title-special-processing"
      ></i>
      {{ courseBaseData.name }}
    </h1>
    <h2
      v-if="courseBaseData.brief"
      class="brief"
    >{{courseBaseData.brief}}</h2>
    <div>
      <p>包含{{ courseNum }}门课程</p>
      <p v-if="invalidTime">有效期：{{invalidTime}}</p>

    </div>

  </div>
</template>
<script>
import { mapState } from 'vuex';
import { dateTime } from '../../../utils/tools';

export default {
  data() {
    return {
      courseNum: 0,
      invalidTime: null, // 课程有效期
    };
  },
  computed: {
    ...mapState(['courseBaseData']),
  },
  watch: {
    courseBaseData() {
      const { packageProductRespList, packageGroupWebRespList } = this.courseBaseData;
      let num = packageProductRespList?.length || 0;
      (packageGroupWebRespList || []).forEach((element) => {
        num += element.selectProductNum;
      });
      this.courseNum = num;
      this.invalidTime = this.courseBaseData.invalidTime ? this.showTime(this.courseBaseData.invalidTime) : null;
    },
  },
  mounted() {

  },
  methods: {
    // ios 时间 '-' 处理
    iosTimeReplace(timeIt) {
      return (timeIt || '').replace(/-/g, '/');
    },
    // 转换时间
    showTime(time) {
      const temp = dateTime(new Date(this.iosTimeReplace(time)).getTime());
      return `${temp.year}.${temp.month}.${temp.day}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.course-num {
  padding: 30px 40px;
  //  margin-bottom: 20px;
  background: #fff;
  > h1 {
    display: -webkit-box;
    // padding: 0 0 20px 0;
    overflow: hidden;
    color: #000;
    font-weight: 600;
    font-size: 33px;
    line-height: 45px;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-bottom: 20px;
  }
  .brief {
    font-size: 22px;
    font-weight: 400;
    color: #666666;
    line-height: 31px;
    margin-bottom: 20px;
  }
  > div {
    display: flex;
    p {
      color: #787878;
      font-size: 24px;
      position: relative;
      padding: 0 15px;
      border-right: 2px solid #e4e4e4;
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        border-right: none;
      }
    }
  }
}
</style>
